import { last } from 'lib/array/arrayUtils'
import { matchLocaleAwarePath } from 'lib/routing/matchLocaleAwarePath'

/**
 * Leaf helper for the current checkout URL segment.
 * Kept out of navigateActions so tour checkout steps can read it without the
 * navigateActions ↔ steps/tours cycle.
 */
export function getCurrentCheckoutPage(state: App.State): string | undefined {
  const isCheckoutPage = matchLocaleAwarePath(state.router.location.pathname, { path: '/:regionCode/checkout', exact: false })
  return isCheckoutPage ? last(state.router.location.pathname.split('/')) : undefined
}
